import { SET_CATALOG_STYLE } from '../actionsTypes';
import { GRID_STYLE, LIST_STYLE } from '../../constants';

const setViewStyle = (styleType) => {
  const payload = styleType === GRID_STYLE ? GRID_STYLE : LIST_STYLE;
  return { type: SET_CATALOG_STYLE, payload };
};

export default setViewStyle;
